// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2hCwP","detailsBorder":"styles_detailsBorder__nO-Ud"};